import { useDeepCompareCallback } from 'use-deep-compare';
import { mergeRefs } from 'utilsTS/react';

export function useRefs<T>(...refs: Array<React.Ref<T> | undefined>) {
    return useDeepCompareCallback(mergeRefs<T>(...refs), [refs]);
}
